import { TOKEN_TYPE } from "../TokenType.js";
import Token from "../Token.js";

export default class CommaToken extends Token {
    constructor( value ) {
        super( TOKEN_TYPE.COMMA, value );
    }

    toString() {
        return "separator";
    }
}
